import { levelKgs } from '@src/data/utils';
import { useSquash } from '@src/hooks/useSquash';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import { BiCheckCircle, BiLeaf } from 'react-icons/bi';
import { HStack, theme, VStack } from 'ui_2';

export const GrowthRewards = () => {
  const { activeSquash } = useSquash();
  const level = activeSquash?.onChainLevel;

  const { width } = useWindowDimensions();

  return (
    <div className='w-full'>
      <div className='text-[12px] font-normal'>GROWTH REWARDS</div>
      {level !== undefined && (
        <HStack className='items-center justify-center'>
          {levelKgs.map((reward, index) => (
            <HStack key={index}>
              <VStack className='items-center'>
                {index === 0 ? (
                  <div className='flex h-[20px] w-[20px] items-center justify-center'>
                    <div className='flex h-[16.667px] w-[16.667px] items-center justify-center rounded-full border-[1.5px] border-ticket'>
                      <BiLeaf color={theme.colors.ticket} size={10} />
                    </div>
                  </div>
                ) : level >= index ? (
                  <div className='flex h-[20px] items-center'>
                    <BiCheckCircle className='text-ticket' size={20} />
                  </div>
                ) : (
                  <div className='-mt-[1px] flex h-[21px] flex-col items-center'>
                    <div className='text-[10px]'>{reward}</div>
                    <div className='-mt-[2px] h-[5.608px] w-[9.877px] flex-shrink-0 bg-ticket' />
                  </div>
                )}
                <HStack className='text-[10px] font-normal text-gray-500'>
                  <span>{index === 0 ? 'MINT' : index}</span>
                  {index > 0 && <span>&nbsp;LVL</span>}
                </HStack>
              </VStack>
              {index !== levelKgs.length - 1 && (
                <div
                  className={`mt-[10px] h-[1px] ${
                    width > 500 ? 'w-12' : 'w-8'
                  } ${level > index ? 'bg-ticket' : 'bg-gray-200'}`}
                />
              )}
            </HStack>
          ))}
        </HStack>
      )}
    </div>
  );
};
